import styled from '@emotion/styled/macro';

export const Title = styled.h2`
  padding: 0 14px;
  font-family: 'FuturaStd';
  font-size: ${14 / 16}rem;
  line-height: 22px;
  text-transform: uppercase;
  color: var(--brand-black);
  @media (min-width: 800px) {
    padding: 0 30px;
  }
`;

export const Widget = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 20px 0;
  border: 1px solid #e6e6e6;
  box-sizing: border-box;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  background: #ffffff;
  @media (min-width: 800px) {
    gap: 20px;
    padding: 30px 0;
  }
  p {
    padding: 0 14px;
    font-size: ${14 / 16}rem;
    @media (min-width: 800px) {
      padding: 0 30px;
    }
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 0 10px;
  @media (min-width: 800px) {
    padding: 0 30px;
  }
`;
